import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertNotificationComponent } from './components/ui-components/alert-notification/alert-notification.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertNotificationComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'mv-backoffice-frontend';
}
